export default __webpack_public_path__ + "static/media/rest3.77dad56c.jpg";